import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form } from 'antd';
import RegisterAnimalFields from "./RegisterAnimalFields";
import { 
	getFarmAnimalDetails, doFarmAnimalCreate, doFarmAnimalUpdate 
} from "../../../../redux/farmanimal/farmAnimalState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { FormatDateValue, getAnimalTypeRoute } from "../../../../utils/index";

const RegisteredAnimalsForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, animalTypeId, ...props}) => {
	const { recordId, mode } = props;  	
	const [form] = useForm();
	
	useEffect(() => {		
		getRecord({recordId: recordId, type_id: animalTypeId});
	}, [recordId, getRecord, animalTypeId]);
	
	useEffect(() => {
		if(recordData){
			const { date_of_birth, ...restData } = recordData;
			const initialValues = {
				date_of_birth: date_of_birth ? FormatDateValue(date_of_birth) : null,
				type_id:animalTypeId,
				...restData				
			};
			form.setFieldsValue(initialValues);
		}
	}, [recordData, form]);
	
	const onSubmit = (formData) => {	
		try {
			formData.date_of_birth = formData.date_of_birth ? formData.date_of_birth.format('YYYY-MM-DD') : null;
			formData.type_id = animalTypeId;
			formData.id = recordId ?? 0;
			formData.id > 0 ? doUpdate(formData): doCreate(formData); 
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

	return (
		<Card extra={"w-full h-full p-4"}>
			<Form form={form} className="form"
				layout="vertical"
				onFinish={onSubmit}
			>   
				<RegisterAnimalFields recordData={recordData} mode={mode} form={form} isAdmin={true} typeId={animalTypeId}/>

				<CrudButtons baseRoute={`/console/registered-animals/${getAnimalTypeRoute(animalTypeId)}`} mode={mode} recordId={recordId}/>
			</Form>	 	
		</Card>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.farmAnimal.details?.data,
	requesting: state.farmAnimal.details?.requesting,
	success: state.farmAnimal.details?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFarmAnimalDetails(id)),
	doCreate: (data) => dispatch(doFarmAnimalCreate(data)),
	doUpdate: (data) => dispatch(doFarmAnimalUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisteredAnimalsForm);